/**
 * Full-screen tier boss incoming warning overlay.
 * Props: warning — { tier } object from s.tierBossWarning, or null/undefined.
 * Renders nothing when warning is falsy.
 */
export function TierBossWarning({ warning }) {
  if (!warning) return null;
  return (
    <div className="tier-boss-warning">
      <div className="tier-boss-warning__skull">💀</div>
      <div className="tier-boss-warning__title">TIER BOSS INCOMING</div>
      <div className="tier-boss-warning__sub">Tier {warning.tier} Warlord awakens…</div>
    </div>
  );
}
